import { render, staticRenderFns } from "./component-file-upload.vue?vue&type=template&id=5e464b2f"
import script from "./component-file-upload.vue?vue&type=script&lang=js"
export * from "./component-file-upload.vue?vue&type=script&lang=js"
import style0 from "./component-file-upload.vue?vue&type=style&index=0&id=5e464b2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports